import React,{useState,useEffect} from "react";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col} from "reactstrap";
import {getDepositLogs} from 'network/ApiAxiosTickets'

const DepositLogs = (props) => {
    const [list, setlist] = useState('');
    useEffect(() => {
        fetchList()
    }, []);

    const fetchList = async()=>{
        const resp = await getDepositLogs()
        setlist(resp.data)
      }


   
    return (
          <>
            <Col className="mb-2" xs="auto" xl="12" >
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center text-center">
                    <Col xs="12">
                      <h3 className="mb-0" > Last 50 Deposits </h3>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="align-self-center text-center"  >
                    {list && list.map((listItem)=>{
                        return <Row>
                            <p>{listItem.content}</p>
                        </Row>
                    })}
                </CardBody>
              </Card>
            </Col>
          </>
                );
  
            }
            
            export default DepositLogs;